/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import axios from 'axios';
import { batchActions } from 'redux-batched-actions';
// material
import { displayErrorMessage, exportcsv } from '@insticator/insticator-ui';
// utils
import { asyncGetExportData } from 'utils/api/commenting';


/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export const EXPORTING_COMMENTING_ANALYTICS = 'EXPORTING_COMMENTING_ANALYTICS';

export const exportCommentingAnalytics = (commentingUnitUUID, format, callback) => dispatch => {
  dispatch(exportingCommentingAnalytics(true));
  asyncGetExportData(commentingUnitUUID, format)
    .then(response => {
      exportcsv(response.data, `userprofiles.${format.toLowerCase()}`, null);
      dispatch(exportCommentingAnalyticsSuccess());
      if (callback) callback();
    }).catch(error => {
      let errorMessage = error.response.status === 404 ? 'No commenting recorded yet to the selected site.' : 'There was an error on exporting the Commenting analytics.';
      setTimeout(() => { dispatch(exportCommentingAnalyticsFail(errorMessage)) }, 1500);
    });
}

const exportingCommentingAnalytics = (status) => ({
  type: EXPORTING_COMMENTING_ANALYTICS,
  status
});

const exportCommentingAnalyticsSuccess = () => batchActions([
  exportingCommentingAnalytics(false),
]);

const exportCommentingAnalyticsFail = (message) => batchActions([
  exportingCommentingAnalytics(false),
  displayErrorMessage(message)
]);
